import React, { useState } from 'react';
import Button from '../../../audi-ui-components/Button';
import CaretDown from '../../../audi-ui-components/icons/CaretDown';
import CaretUp from '../../../audi-ui-components/icons/CaretUp';
import IconWarranty from '../../../audi-ui-components/icons/Warranty';
import NavBar from '../../../audi-ui-components/NavBar';
import TickGreen from '../../../audi-ui-components/icons/TickGreen';
import moment from 'moment';
import { gtmPush } from '../../../lib/gtm';

const getFactoryWarrantyYears = (warrantyDetails) => {
  var years = 3;
  warrantyDetails.forEach(e => {
    if (e.warrantyType == "Factory Warranty") {
      years = Number(e.warrantyEndDate.substring(0, 4)) - Number(e.warrantyStartDate.substring(0, 4));
      return years;
    }
  });
  return years;
}

const FormatDate = (dateStr) => {
  return moment(dateStr).format('Do MMMM YYYY');
}

const Warranty = ({
  warrantyDetails
}) => {

  const [activeTab, setActiveTab] = useState(0);

  const stdWarrantyYrs = Array.isArray(warrantyDetails) && warrantyDetails.length > 0
    ? getFactoryWarrantyYears(warrantyDetails)
    : 3;

  const currentWarranties = warrantyDetails?.filter(w => {
    return moment().isBefore(w.warrantyEndDate) && moment().isAfter(w.warrantyStartDate);
  }) || [];

  const pastWarranties = warrantyDetails?.filter(w => {
    return !(moment().isBefore(w.warrantyEndDate) && moment().isAfter(w.warrantyStartDate));
  }) || [];

  const tabActions = [];
  if (currentWarranties.length > 0) tabActions.push({ label: 'Active' });
  if (pastWarranties.length > 0) tabActions.push({ label: 'Inactive' });

  const currentTabIndex = currentWarranties.length > 0 ? 0 : -1;
  const pastTabIndex = currentWarranties.length > 0 && pastWarranties.length > 0 ? 1 : (pastWarranties.length > 0 ? 0 : -1);

  return (
    <div className="col-12 col-medium-6 pb-3 vehicle-details">
      <div className="aui-color-gray95 mt-3 mb-3 pb-5" style={{ height: '100%' }}>
        <div className="row h-100">

          <div className="col-12 panel">
            <div className="py-4">
              <div className="col-12 px-6">
                <IconWarranty />
              </div>
              <div className="col-12 px-6">
                <h2 className="aui-headline-3"><b>Audi Warranty</b></h2>
              </div>
              <div className="col-12 px-6 description">
                Your Audi comes with a {stdWarrantyYrs} year, unlimited kilometre factory warranty as standard.
              </div>
              <div className="col-12 px-6">
                {(!Array.isArray(warrantyDetails) || warrantyDetails.length === 0) && (
                  <div className="pt-3">No warranty information found for this vehicle.</div>
                )}
                {warrantyDetails && warrantyDetails.length > 0 && (
                  <>
                    <NavBar
                      actions={tabActions}
                      activeIndex={activeTab}
                      onActionClick={(idx) => setActiveTab(idx)}
                      navType="tab"
                      className="recalls-nav mb-4"
                    />

                    {activeTab === currentTabIndex && currentWarranties.length > 0 && (
                      <div className="status-group mb-5" style={{ marginTop: '2rem' }}>
                        {currentWarranties.map((w, idx) => {
                          const isExpired = moment().isAfter(w.warrantyEndDate);
                          const status = 'Active';

                          return (
                            <div key={'warranty-current-' + idx} className="mt-3 details-accordion">
                              <details onToggle={(e) => { if (e.currentTarget.open) gtmPush("myAudi_click", "warranty_accordian", "warrenty_type_active"); }}>
                                <summary>
                                  <div className="title">
                                    <span className="label-wrap">
                                      <TickGreen small style={{ marginRight: '8px', flexShrink: 0 }} />
                                      <span className="label">Warranty Type</span>
                                    </span>
                                    <span className="value">{w.warrantyType}</span>
                                  </div>
                                  <div className="carets">
                                    <CaretDown className="down" small />
                                    <CaretUp className="up" small />
                                  </div>
                                </summary>
                                <div className="item">
                                  <span className="label">Status</span>
                                  <span className="value">{status}</span>
                                </div>
                                <div className="item">
                                  <span className="label">Start Date</span>
                                  <span className="value">{FormatDate(w.warrantyStartDate)}</span>
                                </div>
                                <div className="item pr-5">
                                  <span className="label">Expiry Date</span>
                                  <span className="value">{FormatDate(w.warrantyEndDate)}</span>
                                </div>
                              </details>
                            </div>
                          );
                        })}
                      </div>
                    )}

                    {activeTab === pastTabIndex && pastWarranties.length > 0 && (
                      <div className="status-group mb-5" style={{ marginTop: '2rem' }}>
                        {pastWarranties.map((w, idx) => {
                          const isExpired = moment().isAfter(w.warrantyEndDate);
                          const status = isExpired ? 'Expired' : 'Not yet active';

                          return (
                            <div key={'warranty-past-' + idx} className="mt-3 details-accordion">
                              <details onToggle={(e) => { if (e.currentTarget.open) gtmPush("myAudi_click", "warranty_accordian", "warrenty_type_inactive"); }}>
                                <summary>
                                  <div className="title">
                                    <span className="label">Warranty Type</span>
                                    <span className="value">{w.warrantyType}</span>
                                  </div>
                                  <div className="carets">
                                    <CaretDown className="down" small />
                                    <CaretUp className="up" small />
                                  </div>
                                </summary>
                                <div className="item">
                                  <span className="label">Status</span>
                                  <span className="value">{status}</span>
                                </div>
                                <div className="item">
                                  <span className="label">Start Date</span>
                                  <span className="value">{FormatDate(w.warrantyStartDate)}</span>
                                </div>
                                <div className="item pr-5">
                                  <span className="label">Expiry Date</span>
                                  <span className="value">{FormatDate(w.warrantyEndDate)}</span>
                                </div>
                              </details>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="">
              <div className="buttons px-6">
                <Button variant="primary" className="" href="https://www.audi.com.au/en/owners/warranty/" target="_blank">See what's covered</Button>
              </div>
              <div className="px-6 mt-4 note disclaimer">*Warranty eligibility is subject to adhering to the terms and conditions of your warranty.</div>
            </div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default Warranty;
